// import React from 'react';

// const GoogleMap = () => {
//     React.useEffect(() => {
//         // Load the Google Maps JavaScript API script
//         const googleMapScript = document.createElement('script');
//         googleMapScript.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyA-g3x5rdIO5kDV5Qy6mDCO_wSHCZfCOik`;
//         googleMapScript.async = true;
//         window.document.body.appendChild(googleMapScript);
//         googleMapScript.addEventListener('load', () => {
//             initMap();
//         });
//     }, []);

//     const initMap = () => {
//         // The location of your event (example: Kozhikode)
//         const eventLocation = { lat: 11.26283391323257, lng: 75.76730194673915 };
//         // The map, centered at the event location
//         const map = new window.google.maps.Map(document.getElementById("map"), {
//             zoom: 15,
//             center: eventLocation,
//         });
//         // The marker, positioned at the event location
//         new window.google.maps.Marker({
//             position: eventLocation,
//             map: map,
//         });
//     };
//     return (
//         <div className="google-map-container">
//             <div className="container">
//                 <div className="row">
//                     <div className="col-md-12 p-0 text-center">
//                         <h2 data-aos="fade-up" data-aos-delay="100">
//                             <span className="speaker-pattern"></span>Event Location<span className="speaker-pattern"></span>
//                         </h2>
//                     </div>
//                     <div className="col-md-12 pt-5 pb-5 mt-5">
//                         <div id="map" style={{ width: '100%', height: '400px' }}></div>
//                     </div>
//                 </div>
//             </div>
//         </div>

//     );
// };

// export default GoogleMap;

import React from 'react';

const EmbeddedGoogleMap = () => {
    return (
        <div className="google-map-container mapContainer p-2" style={{ width: '100%', height: '100%' }}>
            {/* <div className="text-center mb-4">
                <h2 className="text-2xl font-semibold text-gray-800">
                    Event Location
                </h2>
            </div> */}
            <div className="w-full h-[350px]">
                <iframe 
                    src='https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d3922.635623549268!2d76.2158103!3d10.5293384!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ba7ee52f3f4ed55%3A0xab406304afe9aad8!2sKerala%20Sahitya%20Academy%20Hall%20Thrissur!5e0!3m2!1sen!2sin!4v1750074309660!5m2!1sen!2sin'
                    width="100%"
                    height="100%"
                    style={{ border: 0 }}
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    title="Kerala Sahitya Academy Location"
                ></iframe>
            </div>
        </div>
    );
};

export default EmbeddedGoogleMap;
